__turbopack_context__.v({
  "action": "CreatorAcquisitionPrompt-module-scss-module__auIVYa__action",
  "body": "CreatorAcquisitionPrompt-module-scss-module__auIVYa__body",
  "card": "CreatorAcquisitionPrompt-module-scss-module__auIVYa__card",
  "copy": "CreatorAcquisitionPrompt-module-scss-module__auIVYa__copy",
  "cta": "CreatorAcquisitionPrompt-module-scss-module__auIVYa__cta",
  "eyebrow": "CreatorAcquisitionPrompt-module-scss-module__auIVYa__eyebrow",
  "heading": "CreatorAcquisitionPrompt-module-scss-module__auIVYa__heading",
  "icon": "CreatorAcquisitionPrompt-module-scss-module__auIVYa__icon",
  "illustration": "CreatorAcquisitionPrompt-module-scss-module__auIVYa__illustration",
  "message": "CreatorAcquisitionPrompt-module-scss-module__auIVYa__message",
  "root": "CreatorAcquisitionPrompt-module-scss-module__auIVYa__root",
});
